import { createSlice } from "@reduxjs/toolkit";

const b2bCompanies = createSlice({
  name: "b2bCompanies",
  initialState: {
    companies: [],
    economicGroups: [],
  },
  reducers: {
    setCompanies(state, { payload }) {
      state.companies = payload;
    },
    setEconomicGroups(state, { payload }) {
      state.economicGroups = payload;
    },
  },
});

export const { setCompanies, setEconomicGroups } = b2bCompanies.actions;

export default b2bCompanies.reducer;
